import { useRouter } from 'next/navigation';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { DEFAULT_LOCALE } from '@/modules/localization';

export const useNavigation = () => {
  const {
    i18n: { language },
  } = useTranslation();
  const { push } = useRouter();

  const generateLink = useCallback(
    (link: string) =>
      language === DEFAULT_LOCALE
        ? link
        : `/${language}${link === '/' ? '' : link}`,
    [language]
  );

  const navigate = useCallback(
    (link: string, scrollToTop: boolean = false) => {
      push(generateLink(link), { scroll: scrollToTop });
    },
    [generateLink, push]
  );

  return { generateLink, navigate };
};
